/* ==========================================================================
   Conquest — search.js
   <predictive-search>: Shopify Predictive Search API rendered via the
   predictive-search section. Keyboard navigable listbox.
   ========================================================================== */
(() => {
  const Conquest = (window.Conquest = window.Conquest || {});

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      this.cache = new Map();
      this.input.addEventListener('input', Conquest.debounce(() => this.onInput(), 220));
      this.input.addEventListener('keydown', (e) => this.onKeydown(e));
    }

    async onInput() {
      const term = this.input.value.trim();
      if (!term) { this.close(); return; }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const url = `${(Conquest.routes || {}).predictiveSearch || '/search/suggest'}?q=${encodeURIComponent(term)}&resources[type]=product,article,collection,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
      try {
        let html = this.cache.get(url);
        if (!html) {
          const res = await fetch(url, { signal: this.controller.signal });
          if (!res.ok) throw new Error(res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const section = doc.querySelector('#shopify-section-predictive-search');
          html = section ? section.innerHTML : '';
          this.cache.set(url, html);
        }
        this.results.innerHTML = html;
        this.input.setAttribute('aria-expanded', 'true');
        const count = this.results.querySelector('[data-predictive-count]');
        if (this.status && count) this.status.textContent = Conquest.template((Conquest.strings || {}).searchResults || '[count]', { count: count.dataset.predictiveCount });
      } catch (e) {
        if (e.name !== 'AbortError') this.close();
      }
    }

    onKeydown(e) {
      const options = Array.from(this.results.querySelectorAll('[role="option"]'));
      if (!options.length || !['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) return;
      const current = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
      if (e.key === 'Enter') {
        if (current > -1) { e.preventDefault(); options[current].querySelector('a').click(); }
        return;
      }
      e.preventDefault();
      const next = e.key === 'ArrowDown' ? (current + 1) % options.length : (current - 1 + options.length) % options.length;
      options.forEach((o, i) => o.setAttribute('aria-selected', i === next ? 'true' : 'false'));
      this.input.setAttribute('aria-activedescendant', options[next].id);
      options[next].scrollIntoView({ block: 'nearest' });
    }

    close() {
      this.results.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
})();
